//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
import moment from "moment-timezone";
// calendar-time-zone imports
import { IContainer, IProps, IState } from "./CalendarTimeZone.d";
import { calendarTimeZoneFragments } from "./CalendarTimeZone.gql";
import * as s from "./CalendarTimeZone.styles";
// other components
import { InfoTip } from "@components/tool-tip";
// state
import { IReduxState } from "@reducers/root.reducer";

//////////////////
// COMPONENT
//////////////////
class CalendarTimeZoneCmpt extends React.Component<IProps, IState> {
  private renderInterval?: ReturnType<typeof setInterval>;
  constructor(props: IProps) {
    super(props);

    this.state = {
      timestamp: 0,
    };
  }

  // ~-~-~-~-~-~-~-
  // Lifecycle
  // ~-~-~-~-~-~-~-
  public componentDidMount() {
    this.renderInterval = setInterval(() => {
      // rerender every 60 seconds to update times
      this.setState({ timestamp: new Date().valueOf() });
    }, 60 * 1000);
  }

  public componentWillUnmount() {
    if (this.renderInterval) {
      clearInterval(this.renderInterval);
    }
    delete this.renderInterval;
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { person, calendarId, profileTimeZone, hideInfoTip } = this.props;

    let name = calendarId;
    if (person && person.profile && person.profile.givenName) {
      name = person.profile.givenName;
    }

    // timezone
    let hasTimeZone = false;
    let time = "";
    let tz = "";
    let timeZone = "";
    let timeZoneCode = "";
    if (profileTimeZone) {
      hasTimeZone = true;
      tz = profileTimeZone.timeZone;
      timeZone = tz.replace("_", " ");
      timeZoneCode = moment.tz(tz).format("z");
      time = moment.tz(tz).format("h:mma z");
    }

    if (!hasTimeZone) {
      return <span />;
    }

    const tipText = (
      <div style={{ textAlign: "center" }}>
        {name}
        's primary work time zone
        <br />
        is {timeZone} ({timeZoneCode}
        ).
      </div>
    );

    return (
      <div style={s.container}>
        {hasTimeZone ? <span>{time}</span> : ""}
        {hasTimeZone && !hideInfoTip ? (
          <InfoTip text={tipText} iconStyle={s.tooltipIcon} tipType={"info"} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const CalendarTimeZoneRedux = connect(mapStateToProps, {})(CalendarTimeZoneCmpt);

//////////////////
// RELAY
//////////////////
export const CalendarTimeZone = createFragmentContainer<IContainer>(
  CalendarTimeZoneRedux,
  calendarTimeZoneFragments,
);
